<div class="wrapper">
  <div *ngIf="(customerPendingState$ | async) === pendingState.success">
    <div class="back-link-container confinement">
      <a routerLink="../.." class="back-on-mobile mat-h2 back-link">
        <mat-icon class="back-link-icon">arrow_back</mat-icon>{{ 'NAVBAR.MY_ACCOUNT' | translate }}
      </a>
    </div>
    <mat-card class="confinement">
      <mat-card-title class="mat-title">{{ 'ONLINE_SUBSCRIPTIONS.TITLE' | translate }} </mat-card-title>
      <mat-card-content>
        <mat-list>
          @for (element of releases; track element) { @if (element.download_url) {
          <mat-list-item>
            <button
              matListItemTitle
              mat-button
              class="download-button"
              (click)="download(element)"
              [disabled]="lockedElements.includes(element)"
              [class.button-spinner]="lockedElements.includes(element)"
            >
              <mat-icon>download</mat-icon>
              <span>{{ element.attribute_name }}</span>
            </button>
          </mat-list-item>
          @if (!$last) {
          <mat-divider />
          } } }
        </mat-list>
        <div *ngIf="noReleases">{{ 'ONLINE_SUBSCRIPTIONS.NO_RELEASES' | translate }}</div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="spinner" *ngIf="(customerPendingState$ | async) === pendingState.pending">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="(customerPendingState$ | async) === pendingState.failed" class="wrapper">
    <mat-card class="content-box confinement">
      <mat-card-title class="error-text">
        {{ 'ERROR.TITLE' | translate }}
      </mat-card-title>
      <mat-card-content class="error-text">
        {{ 'ERROR.DESCRIPTION' | translate }}
      </mat-card-content>
    </mat-card>
  </div>
</div>
